export default __webpack_public_path__ + "static/blob7-cf2f815e634fb1fe242c31e880e18555.svg";